import axios from "axios";
import {buildQuery} from "utils/queryUtils";

export const findRegisters = (headers, params) => {
    let query = buildQuery(params, ["email", "passportNo", "fullName"]);
    return axios.get(`${process.env.REACT_APP_IDP_API_URL}/foreigner-registers${query}`, {
        headers
    })
}
